export default {
    "template": "componentsCompany/global/CompanySettings",
    "default_number_format": {
        "decimal_point": ",",
        "decimal_length": 2
    },
    "new_design": true,
    "menu_template": "componentsCompany/global/header/MenuComponent",
    "paginator": {
        "per_page_sizes": [
            10,
            25,
            50,
            100
        ],
        "per_page_default": 10,
        "per_page_by_name": {
            "cards": 25
        }
    },
    "body_size_bootstrap_validator_white_list": [
        "export-import/*",
        "api/export-import/*"
    ]
}